import { Form } from '@anytag/shared-atoms';
import { PasswordFormSchema } from './schema';
import { Template } from './Template';
import { PasswordFormProps, PasswordFormValues } from './types';

export const PasswordForm = ({
  onSubmit,
  defaultValues = { password: '', passwordConfirm: '' }
}: PasswordFormProps) => (
  <Form.Provider
    onSubmit={onSubmit}
    defaultValues={defaultValues}
    zodSchema={PasswordFormSchema}
    className="mx-auto w-107 rounded-none"
  >
    <Template />
  </Form.Provider>
);

export { type PasswordFormValues };
